import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { DataAddCart, ProductData, ResponseAddToCart } from '../../../../../../core/model/Product.model';
import { EmpresaService } from '../../../../../../services/Empresa/Empresa.service';
import { environment } from '../../../../../../../environments/environment';
import { LoginService } from '../../../../../../services/login/login.service';
import { CartService } from '../../../../../../services/generar-pedido/cart/cart.service';
import { SwalService } from '../../../../../../services/swal/swal.service';
import { CheckoutService } from './checkout.service';

@Injectable({
  providedIn: 'root'
})
export class ProductoService {
  public header = {
    headers: new HttpHeaders({
    }),
  };
  empresaId: string;

  private apiUrl = environment.apiUrl;
  public productos: ProductData[] = [];
  public dataListArticuloInvitado: ProductData[] = [];
  public dataListArticuloDistribuidor: ProductData[] = [];

  public productTemp: ProductData; // esta variable es para guardar el producto temporalmente

  constructor(
    private loginService: LoginService,
    private http: HttpClient,
    private swal: SwalService,
    private cart: CartService,
    private empresaService: EmpresaService,
    private checkoutService: CheckoutService
  ) {
    this.empresaService.empresaId$.subscribe(id => {
      this.empresaId = id;
    });
  }

  private addNewItemCart = (item: DataAddCart, productData?: ProductData) => {
    const dataCliente = this.loginService.getDataClientePedido();
    const dataquery = {
      // p : environment.production,
      article_id: item.ClaveArticulo,
      qty: item.Cantidad,
      client_id: dataCliente.client_number,
      almacen_id: item.AlmacenID,
      empresa_id: this.empresaId,
      uid: dataCliente.uid,
      publicoGeneral: dataCliente.es_publicogeneral,
      correo: dataCliente.email,
      option: 'addCart',
      isCedis: item.isCedis,
      productData,
    };
    return this.http
      .post<ResponseAddToCart>(
        this.apiUrl + 'Servicios-web/Cart/CartV2.php',
        dataquery
      )
      .pipe(map((response) => response));
  };

  private validAddToCart = (): boolean => {
    if (this.loginService.isLogged()) {
      const dataUser = this.loginService.getDataClientePedido();
      if (dataUser.permiso_carrito_compras === 'SI') {
        return true;
      }
      return false;
    } else {
      return true;
    }
  };

  /*********** AGREGAR AL CARRITO ***********/
  public addToCart = (item: DataAddCart, articulos: ProductData) => {
    let articulos$: ProductData;
    // console.log('addToCart', item, articulos);
    if (this.validAddToCart()) {
      // validamos si el usuario tiene permisos para agregar
      articulos.CANT_CAR = item.Cantidad;
      articulos.isCedis = item.isCedis;
      articulos.Almacen = item.isCedis ? 'CEDIS' : 'SUCURSAL';
      this.addNewItemCart(item, articulos).subscribe(
        (response: ResponseAddToCart) => {
          if (response.message === 'true') {
            if (response.productData !== undefined) {
              articulos$ = response.productData;
            } else {
              articulos$ = articulos;
            }
            this.cart.addCart$(articulos$); // Aqui es cuando agrega al carrito
            this.checkoutService.itemsOrder();
            this.swal.swalMessesAddCartSuccess(articulos, item.Cantidad);
          } else {
            this.swal.swalArticleInTheCart();
          }
        }
      );
    } else {
      // si no le enviamos un mensaje de información
      this.swal.swalInfo(
        'Añadir a la cesta',
        'Tu usuario no tiene permisos para agregar artículos a la cesta. Para realizar esta acción, contacta al administrador de la cuenta para que te asigne el permiso.'
      );
    }
  };

  /*********** AGREGAR AL CARRITO ***********/
  public addToCartInvitado = (item: DataAddCart, articulos: ProductData) => {
    const dataLocalStorage = JSON.parse(
      localStorage.getItem('items-cart-login')
    );
    this.dataListArticuloInvitado =
      dataLocalStorage !== null
        ? dataLocalStorage
        : this.dataListArticuloInvitado;
    if (!this.isExist(articulos, item.isCedis)) {
      articulos.CANT_CAR = item.Cantidad;
      articulos.isCedis = item.isCedis;
      articulos.Almacen = item.isCedis ? 'CEDIS' : 'SUCURSAL';
      this.dataListArticuloInvitado = [
        ...this.dataListArticuloInvitado,
        articulos,
      ];
      this.dataListArticuloInvitado = this.cart.asignaExistenciaCedis$(
        this.dataListArticuloInvitado
      );
      localStorage.setItem(
        'items-cart-login',
        JSON.stringify(this.dataListArticuloInvitado)
      );
      this.cart.addCartPG$(this.dataListArticuloInvitado);
      this.swal.swalMessesAddCartSuccess(articulos, item.Cantidad);
      return true;
    } else {
      if (dataLocalStorage) {
        this.swal.swalInfo(
          '',
          '<h1 class="title-swal">Este articulo ya se encuentra en tu carrito.</h1>'
        );
        return true;
      }
    }
  };

  private isExist = (product: ProductData, cedis: boolean): boolean => {
    let booleano = false;

    this.dataListArticuloInvitado.forEach((element) => {
      // if (element.ClaveArticulo === product.ClaveArticulo) {
      //   booleano = true;
      // }
      if (cedis) {
        if (
          element.ClaveArticuloProveedor === product.ClaveArticuloProveedor &&
          element.isCedis === true
        ) {
          booleano = true;
        }
      } else {
        if (
          element.ClaveArticuloProveedor === product.ClaveArticuloProveedor &&
          element.isCedis === false
        ) {
          booleano = true;
        }
      }
    });
    return booleano;
  };
}
